<!-- eslint-disable @typescript-eslint/no-unused-vars -->
<script setup>
import { BreadCrumb, Footer, GlobalHeader, NewsList, SideMenu } from '@weathernews/btos-vuecomponent/with-onebox-common-elements/src/index'
import { onMounted } from 'vue'

const route = useRoute()

const props = defineProps({
  breadCrumbList: {
    type: Array,
    default: () => []
  },
  adsKey: {
    type: String,
    required: true
  }
})
const { $ads } = useNuxtApp()
const { $isWebViewFlag: isWebViewFlag } = useNuxtApp()
const isTopicsPage = (route.path || '').includes('topics')
onMounted(() => {
  $ads.init(adsConfig)
})
</script>

<template>
  <div>
    <GlobalHeader :is-web-view-prop="isWebViewFlag" />
    <div :class="['content', { 'app-view': isWebViewFlag }]">
      <BreadCrumb
        v-if="breadCrumbList.length > 0"
        :bread-crumb-list="breadCrumbList"
        :is-web-view-prop="isWebViewFlag"
      />
      <div class="main-sub-container">
        <main class="main">
          <slot />
        </main>
        <sub>
          <div
            id="2.5web_clothes_btf"
            class="ads-btf"
          />
          <NewsList
            v-if="isTopicsPage"
            class="news-list"
            :is-web-view-prop="isWebViewFlag"
            :app-view-show="true"
          />
          <clothesShortTopics
            v-else
            class="news-list"
            :is-web-view-prop="isWebViewFlag"
            :app-view-show="true"
          />
          <div
            id="2.5web_clothes_btm"
            class="ads-btm"
          />
          <ContentRecommend :is-web-view-prop="isWebViewFlag" />
          <SideMenu
            :is-web-view-prop="isWebViewFlag"
            :app-view-show="false"
          />
        </sub>
      </div>
    </div>
    <Footer :is-web-view-prop="isWebViewFlag" />
    <StickyAd />
  </div>
</template>

<style>
html {
  scroll-behavior: unset;
}
</style>

<style lang="scss" scoped>
.content {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding-top: 54px;
  max-width: 1100px;
  margin: 0 auto 0;
  padding-left: 10px;
  padding-right: 10px;
}
.content.app-view {
  padding-top: 15px;
}

.main-sub-container {
  display: flex;
  flex-direction: column;
  gap: 30px;
}

main {
  display: flex;
  flex-direction: column;
  gap: 30px;
  width: 100%;
  .news-list {
    display: none;
  }
}

sub {
  display: flex;
  flex-direction: column;
  gap: 30px;
}

.ads-btf {
  min-height: 50px;
  text-align: center;
  margin: 0px auto;
  position: relative;
}

.ads-btm {
  min-height: 250px;
  text-align: center;
  margin: 0px auto;
  position: relative;
}

@media screen and (min-width: 830px) {
  .content {
    padding-top: 120px;
    margin-top: 15px;
    padding-left: 15px;
    padding-right: 15px;
  }

  .main-sub-container {
    flex-direction: row;
    gap: 30px;
  }

  main {
    width: calc(100% - 330px);
    .news-list.show-in-main {
      display: block;
    }
  }

  sub {
    width:  300px;
    align-self: flex-start;
    .news-list.show-in-main {
      display: none;
    }
  }
}
</style>
